import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import App from './App.vue';
import './styles.css';
import { useAuth } from './stores/auth';

// Import pages
import Login from './pages/Login.vue';
import Dashboard from './pages/Dashboard.vue';
import Form from './pages/Form.vue';

// Create router
const router = createRouter({
  history: createWebHistory('/submit/'),
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login, name: 'login' },
    { path: '/dashboard', component: Dashboard, name: 'dashboard', meta: { requiresAuth: true } },
    { path: '/form', component: Form, name: 'form', meta: { requiresAuth: true } }
  ]
});

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
}

// Create app and pinia
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

// Add navigation guards
router.beforeEach(async (to, from, next) => {
  const auth = useAuth();

  if (to.name === 'login') {
    auth.isInitialized = true;
    next();
    return;
  }

  // Initialize auth state if not already done
  if (!auth.isInitialized) {
    await auth.checkAuth();
  }

  // Check if route requires authentication
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    // Redirect to login if not authenticated
    next({ name: 'login' });
    return;
  }

  if (to.name === 'login' && auth.isAuthenticated) {
    // Redirect to dashboard if already authenticated and trying to access login
    next({ name: 'dashboard' });
    return;
  }

  next();
});

app.use(router);
app.mount('#app');
